import { render, staticRenderFns } from "./OrderSingleNote.vue?vue&type=template&id=2952976e&"
import script from "./OrderSingleNote.vue?vue&type=script&lang=js&"
export * from "./OrderSingleNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports